// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 20254 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { actionStyles } from "@awc/Overrides/Widgets/MyListsDetails/MyListsDetailsActions";
import Star from "@awc/XDL/Icons/Star";
import StarX from "@awc/XDL/Icons/StarX";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, moreActionsSharedStyle, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

actionStyles.titleActionsWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        gap: 22px;
        align-items: center;

        ${xScreen("lte", "sm")} {
            flex-direction: column;
            gap: 0;
        }
    `,
};

actionStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        gap: 10px;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 12px;
        padding-bottom: 12px;
        ${xScreen("lte", "sm")} {
            margin-top: 16px;
        }
    `,
};

actionStyles.actionsWrapperRight = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 1;
        gap: 12px;
    `,
};

actionStyles.statusContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        margin-bottom: 10px;
        align-items: center;
    `,
};

actionStyles.addItemButton = {
    typographyProps: {
        weight: "bold",
        css: css`
            white-space: nowrap;
        `,
    },
    css: css`
        width: 100%;
        padding: 8px 24px;
    `,
    variant: "secondary",
};

actionStyles.removeSelectedButton = {
    typographyProps: {
        weight: "bold",
        css: css`
            white-space: nowrap;
        `,
    },
    css: css`
        width: 100%;
        padding: 0 15px;
    `,
    variant: "secondary",
};

actionStyles.addListButton = {
    css: css`
        width: fit-content;
        padding: 0 15px;
        white-space: nowrap;
    `,
};

actionStyles.editListModal = {
    sizeVariant: "small",
};

actionStyles.copyListModal = {
    sizeVariant: "small",
};

actionStyles.listActionsWrapper = {
    css: css`
        display: flex;
        gap: 7px;
        align-items: center;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            width: 100%;
        }
    `,
};

actionStyles.nameText = {
    variant: "h1",
};

actionStyles.wishlistCountWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 7px;
    `,
};

actionStyles.wishlistLabel = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.singleLineRegular,
    weight: fontConfig.weight.bold,
};

actionStyles.wishlistCount = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.singleLineRegular,
};

actionStyles.iconContainer = {
    css: css`
        width: fit-content;
    `,
};

actionStyles.actionFavoriteClickable = {
    css: css`
        font-size: ${fontConfig.fontSize.singleLineRegular}px;
        line-height: ${fontConfig.lineHeight.regular};
        color: ${color("text.link")};
        width: fit-content;

        &:hover {
            color: ${color("common.ui8")};
        }
    `,
};

actionStyles.starIcon = {
    src: Star,
    color: "primary.main",
    size: 16,
    css: css`
        margin-right: 6px;
        &:hover {
            color: ${color("common.ui8")};
        }
    `,
};

actionStyles.starXIcon = {
    src: StarX,
    size: 16,
    color: "primary.main",
    css: css`
        margin-right: 6px;
        &:hover {
            color: ${color("common.ui8")};
        }
    `,
};

actionStyles.overflowMenu = {
    ...moreActionsSharedStyle.overflowMenu,
};

actionStyles.moreActions = {
    ...moreActionsSharedStyle.moreActionsLink,
};

actionStyles.printButton =
    actionStyles.addTagsButton =
    actionStyles.scheduleButton =
    actionStyles.editButton =
    actionStyles.shareButton =
    actionStyles.hideButton =
    actionStyles.copyButton =
    actionStyles.exportButton =
    actionStyles.deleteButton =
    actionStyles.removeSelectedButton =
        {
            variant: "primary",
            css: css`
                height: fit-content;
                ${xScreen("lte", "sm")} {
                    width: 100%;
                }
            `,
        };

actionStyles.titleWrapper = {
    css: css`
        width: 100%;
        display: flex;
        align-items: baseline;
    `,
};

actionStyles.deleteListModal = { cancelButton: { variant: "secondary" } };

actionStyles.printListModal = { container: { gap: 10 } };
